import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface ParseBankReceiptRequest {
  file: File;
}

export interface ParseBankReceiptResponse {
  currency: string;
  amount: number;
  exchangeRate: number;
  amountKrw: number;
  bankFee: number;
  totalAmountKrw: number;
  // 응답 인터셉터(deserializeDate)가 issuedOn 을 Date 객체로 변환한다. 없으면 빈 문자열.
  issuedOn: Date | string | null;
  refNo: string; // 거래 참조번호 (BRR invoice_number 로 저장)
}

interface ParseBankReceiptPathParameter {}

export const parseBankReceiptKey: YWRKey<ParseBankReceiptPathParameter> = {
  url: () => `/bank_receipt/parse`,
  method: "post",
};

export default function useParseBankReceipt() {
  const fetcher = useFetcher<
    ParseBankReceiptRequest,
    ParseBankReceiptResponse
  >();
  return useYWR(parseBankReceiptKey, fetcher, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
